import { useTheme } from "@mui/material";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useReduxModal } from "./hooksModal";

export function useCommon() {
    // ********************************************
    //  Style
    // ********************************************
    const theme = useTheme();

    // ********************************************
    //  공통 & Redux
    // ********************************************
    const navigate = useNavigate();

    // ********************************************
    //  모달 관리
    // ********************************************
    const inputRef = useRef({});
    const { showModal, hideModal, showProgressModal } = useReduxModal();

    return { 
        theme, 
        navigate, 
        inputRef,
        showModal,
        hideModal,
        showProgressModal
    };
}